import React from "react";
import PropTypes from "prop-types";
import { useParams, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "../store/hooks";
import { selectUser, selectIsLoggedIn } from "../store/userSlice";
import { selectHasClubPermissions, selectPermissionsLoaded, selectIsClubOwner } from "../store/permissionsSlice";
import MKBox from "./MKBox";
import { CircularProgress, Typography } from "@mui/material";

function ProtectedRoute({ children }) {
  const { id: clubId, eventId } = useParams();
  const location = useLocation();
  const user = useAppSelector(selectUser);
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const permissionsLoaded = useAppSelector(selectPermissionsLoaded);
  
  // Get club ID from URL params (for club editing) or location state (for event editing)
  const targetClubId = clubId || location.state?.clubId;
  
  const hasPermissions = useAppSelector(state => selectHasClubPermissions(state, targetClubId));
  const isOwner = useAppSelector(state => selectIsClubOwner(state, targetClubId));
  
  // Determine if user is authorized
  const authorized = hasPermissions || isOwner;
  
  // Show loading while permissions are being fetched
  if (!permissionsLoaded && isLoggedIn && user?.id) {
    return (
      <MKBox sx={{ p: 4, textAlign: "center" }}>
        <CircularProgress />
      </MKBox>
    );
  }
  
  // Check if user has required data
  if (!isLoggedIn || !user?.id || !targetClubId) {
    return <Navigate to="/not-authorized" replace />;
  }
  
  // Check if user is authorized
  if (!authorized) {
    return <Navigate to="/not-authorized" replace />;
  }
  return children ? children : <Outlet />;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node,
};

export default ProtectedRoute; 